// use a script tag or an external JS file
 document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)

    // LottieScrollTrigger({
    //     target: "#lottie-container",
    //     path: "https://cdn.shopify.com/s/files/1/0585/3390/4557/files/Sunrise_v01.json?v=1750144958",
    //     speed: "medium",
    //     scrub: 2, // seconds it takes for the playhead to "catch up"
    //     // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See /docs/v3/Plugins/ScrollTrigger
    //   });
    // // gsap code here!
    const animContainer = document.getElementById("lottie-container");
    const lottieLink = animContainer.dataset.lottieLink;

    const anim = lottie.loadAnimation({
      container: animContainer,
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: lottieLink
    });
  
    anim.addEventListener("DOMLoaded", function () {
        const totalFrames = anim.totalFrames;
        console.log(totalFrames);
        const obj = { frame: 0 };
    
        gsap.to(obj, {
          frame: totalFrames - 1,
          ease: "none",
          scrollTrigger: {
            trigger: "#lottie-container",
            start: "top bottom",
            end: "60% top",
            scrub: true,
          },
          onUpdate: () => {
            anim.goToAndStop(obj.frame, true);
          }
        });
      });


      const staggerEls = document.querySelectorAll(".wt-lottie-animation__content h2");

      staggerEls.forEach(el => {
        const words = el.innerHTML.trim().split(" ");
        el.innerHTML = words.map(word => `<span>${word} </span>`).join("");
        el.style.display = "block";
      });

      const staggerEls2 = document.querySelector(".wt-lottie-animation__content p");
      
      staggerEls2.style.display = "block";

      gsap.fromTo(".wt-lottie-animation__content h2 span",
        {
          opacity: 0,
          y: 20
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.4,
          ease: "power2.out",
          stagger: 0.05,
          scrollTrigger: {
            trigger: ".wt-lottie-animation__content",
            start: "top 80%",
            end: "bottom top",
            toggleActions: "play none none reverse"
          }
        }
      );
      gsap.fromTo(".wt-lottie-animation__content p",
        {
          opacity: 0,
          y: 20,
        },
        {
            opacity: 1,
            y: 0,
            delay: 0.8,
            duration: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".wt-lottie-animation__content",
            start: "top 80%",
            end: "bottom top",
            toggleActions: "play none none reverse"
          }
        }
      );
   });